import * as React from 'react'
import { SVGProps } from 'react'
import PropTypes from 'prop-types'
interface SVGRProps {
    title?: string;
    titleId?: string;
}
function SvgChevronRight({
    title,
    titleId,
    ...props
}: SVGProps<SVGSVGElement> & SVGRProps) {
    return (
        <svg
            viewBox="0 0 15 25"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
            aria-labelledby={titleId}
            {...props}
        >
            {title ? <title id={titleId}>{title}</title> : null}
            <path
                d="M12.774 2.436 2.376 12.834M2.32 12.89l10.453 10.454"
                stroke="currentColor"
                strokeWidth={3}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}
SvgChevronRight.propTypes = {
    title: PropTypes.string,
    fill: PropTypes.string,
    width: PropTypes.string,
    height: PropTypes.string,
    stroke: PropTypes.string,
    color: PropTypes.string,
}
export default SvgChevronRight
